import { useState } from "react";

const randomSixDigitNumber = () => {
  const sizPaddingZeroes = "000000";
  return (Math.random().toString() + sizPaddingZeroes).slice(2, 6 + 2)
};

export const useRandomId = (prefix = 'id-') => {
  const [randomNumber] = useState(randomSixDigitNumber());
  return [prefix + randomNumber];
};